module.exports = __webpack_public_path__ + "img/default-poster.07a7833a.png";